<template>
  <el-select
    v-model="outStatus"
    clearable=""
    style="width: 100%;"
    placeholder="请选择订单状态"
    @change="onChange">
    <el-option
      label="全部"
      :value="null">
    </el-option>
    <el-option
      v-for="item in list"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>
<script>
import { OrderStatusName } from '../../utils/index'
export default {
  name: 'OrderStatusSelect',
  props: {
    callback: Function,
    value: {
      required: true
    },
    option: {
      type: Object
    }
  },
  data() {
    return {
      list: OrderStatusName
    }
  },
  computed: {
    outStatus: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onChange() {
      this.callback && this.callback()
    }
  }
}
</script>
